import { render, staticRenderFns } from "./ShowcasePageTable.vue?vue&type=template&id=3b8a64bc&scoped=true&"
import script from "./ShowcasePageTable.vue?vue&type=script&lang=ts&"
export * from "./ShowcasePageTable.vue?vue&type=script&lang=ts&"
import style0 from "./ShowcasePageTable.vue?vue&type=style&index=0&id=3b8a64bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a64bc",
  null
  
)

export default component.exports